import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComentarioUICamViewModel } from '../../unidad-inspeccion-datosbasicos.types';

@Component({
    selector: 'app-comentario-ui-list',
    templateUrl: './comentario-ui-list.component.html',
    styleUrls: ['./comentario-ui-list.component.scss'],
})
export class ComentarioUiListComponent {
    @Input() comentariosUI: ComentarioUICamViewModel[];
    @Input() hasDeletingAccess: boolean;
    @Output() delete = new EventEmitter<number>();

    isCollapsedCabecera = false;

    onDelete(item: ComentarioUICamViewModel): void {
        this.delete.emit(item.Id);
    }
}
